import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Services } from 'src/app/services/api.service';
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';
import { CommonModule } from '@angular/common';
import { ErrorMessageService } from 'src/app/services/error-message.util';

@Component({
  selector: 'app-modal-change-photo',
  templateUrl: './modal-change-photo.component.html',
  styleUrls: ['./modal-change-photo.component.sass'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ImageCropperComponent]
})
export class ModalChangePhotoComponent {
  @Output() closeModalChangePhoto = new EventEmitter<any>();
  @Output() callGetMembershipFunction = new EventEmitter<any>();
  @Input() membershipCard: any;
  gdprQuestions: any = [];
  gdprQuestionsForm!: FormGroup;
  imageChangedEvent: any;
  croppedImage: any;
  errorMessage: string = '';
  loader = document.getElementById("loader-container");
  gdprTextId: any;

  constructor(private Services: Services, private readonly errorMessageService: ErrorMessageService) { }

  ngOnInit() {
    if(!this.membershipCard.gdprPhoto) {
      this.Services.getGdprForUpdatePhotoMembership().subscribe(Response => {
        const res: any = Response;
        this.gdprQuestions = res.data.questions;
        this.gdprTextId = res.data.id;
    
        let fields: any = {};
        this.gdprQuestions.forEach((item: any) => {
          const key = `gdprQuestion${item.id}`;
          fields[key] = new FormControl(false);
        });
    
        this.gdprQuestionsForm = new FormGroup(fields);
      });
    } else {
      this.gdprQuestionsForm = new FormGroup({});
    }
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.clearErrorMessage();
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  removeImage() {
    this.imageChangedEvent = "";
    this.croppedImage = "";
  }

  clearErrorMessage() {
    this.errorMessage = '';
  }

  closeModalOnClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    target.classList.contains('modal-overlay') && this.closeModalChangePhoto.emit();
  }


  onSubmit() {
    const formValues = this.gdprQuestionsForm.value;
    let checkedGdprQuestions = '';
    let allChecked = true;
  
    for (const key in formValues) {
      if (formValues.hasOwnProperty(key)) {
        if (formValues[key] === true) {
          const questionId = key.replace('gdprQuestion', '');
          checkedGdprQuestions += questionId + ',';
        } else {
          allChecked = false;
        }
      }
    }
  
    const isCroppedImageEmpty = !this.croppedImage || this.croppedImage.trim() === '';
  
    switch (true) {
      case !allChecked && isCroppedImageEmpty:
        this.errorMessage = this.errorMessageService.getErrorMessage('consentImgErrMsg');
        return;
      case !allChecked:
        this.errorMessage = this.errorMessageService.getErrorMessage('consentDataErrMsg');
        return;
      case isCroppedImageEmpty:
        this.errorMessage = this.errorMessageService.getErrorMessage('imageUploadError');
        return;
      default:
        this.updatePhotoMembershipApi(checkedGdprQuestions);
    }
  }
  
  updatePhotoMembershipApi(checkedGdprQuestions: string) {
    const body = {
      "imageData": this.croppedImage.split("data:image/png;base64,")[1],
      "imageFilename": "nova slika",
      "gdprData": {
          "gdprTextId": this.gdprTextId,
          "gdprAnswers": checkedGdprQuestions
      }
    }
  
    this.Services.updatePhotoMembership(body, this.membershipCard.profileId).subscribe((Response:any) => {
      this.closeModalChangePhoto.emit();
      //this.callGetMembershipFunction.emit();
      window.location.reload();
    })
  }
}
